export const CLIENT_URL = "https://app.c2perform.com/";
export const SOCKET_URL = "wss://as-us-dev.c2perform.com:8443/";
export const API_BASE_URL = "https://as-us-dev.c2perform.com:8443/api/";
export const UPLOAD_API_URL = "https://as-us-dev.c2perform.com:8443/api/";
export const MEDIA_URL = "as-us-dev.c2perform.com:8443";
export const DOMAIN = "dev-tor-wss.c2perform.com";
export const ENVIRONMENT = "dev";
export const RECORDING_ENABLE = true;
export const SCREENDRAW_ENABLE = true;
export const API_EVENT_BASE_URL = "";
export const LOGOUT_CODE_PARAM = "100";
export const DYNAMIC_GROUP_URL = "https://app.c2perform.com/window_app/managed-groups.php";
export const SCHEDULED_CALLS_LINK = "";
export const CALL_RECORDINGS_LINK = "";
